import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { PROVIDERS_V3_BY_DISTRICT } from "Services/queries";
import { generateUrl } from "Services/withDefaultParams";
import Routes from "Configs/routes";
import { sendMetriks } from "Services/sendMetriks";
import ListOfProvidersWithInjectedTariffs from "ComponentsUI/ListOfProvidersWithInjectedTariffs";
import { HeaderTextSeo } from "ComponentsUI/SeoBlock";

export default function ProvidersContainer(props) {
	const routerParams = useParams();

	const {
		ApplicationModel: { ratesModel, windowSizeModel, text },
		districtsOne,
	} = props;

	const providersQuery = useQuery(PROVIDERS_V3_BY_DISTRICT, {
		variables: {
			district_id: +routerParams.districtId,
			sort: "-vip_provider,vip_b2c_priority,-rating.expert.final,name",
			random: false,
		},
	});

	useEffect(() => {
		if (!providersQuery.loading) {
			sendMetriks("PROVIDERS_DISTRICT_LOAD", providersQuery.data.providersV3.data);
		}
	}, [providersQuery]);

	if (providersQuery.loading) {
		return null;
	}

	let providers = JSON.parse(JSON.stringify(providersQuery.data.providersV3.data));

	providers.forEach((provider) => {
		provider.linkProviderSelect = generateUrl(Routes.ProviderDetails.route, {
			providerName: provider.url_name,
			regionUrl: provider.region.url,
		});
		provider.linkproviderRates = generateUrl(Routes.ProviderRates.route, {
			providerName: provider.url_name,
			regionUrl: provider.region.url,
		});
		provider.linkProviderReviews = generateUrl(Routes.ProvidersReviewListOld.route, {
			regionUrl: provider.region.url,
			providerName: provider.url_name,
		});
		provider.linkProviderConnect = generateUrl(Routes.OrderHome.route, {
			regionUrl: provider.region.url,
		});
	});
	if (!!providers.length) {
		return (
			<>
				<HeaderTextSeo header={`${text.PROVIDERS_BY_AREA} ${districtsOne?.name}`} />
				<ListOfProvidersWithInjectedTariffs
					hideProviderLogo={true}
					text={text}
					windowSize={windowSizeModel.windowSizes}
					items={providers}
					flat={ratesModel.orientation}
					pageName="district_prov"
					districtsOne={districtsOne}
				/>
			</>
		);
	} else {
		return null;
	}
}
